// extracted by mini-css-extract-plugin
export default {"page":"PreAssessment_page__mEmv8","cardShadow":"PreAssessment_cardShadow__BiA2D","headerDisplay":"PreAssessment_headerDisplay__RXLO3"};